import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import TextInputField from "../../../components/forms/TextInputField";
import FormError from "../../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

class RegisterPalletForm extends Component {

  render() {
    let {errors, handleSubmit, submit, products, activatePalletId, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Pallet Id"
              name="palletId"
              component={TextInputField}
              active={activatePalletId}
              serverError={this.props.errors.palletId}
              />
            <Field 
              label="Product"
              name="inventorySku"
              component={DropDownInputField}
              data={products}
              valueKey="sku"  
              titleKey="sku" 
              showBlank={true}
              serverError={this.props.errors.inventorySku}
              />
            <Field 
              label="Quantity"
              name="quantity"
              type="number"
              normalize={numerical}
              component={TextInputField}
              serverError={this.props.errors.quantity}
              />              
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

RegisterPalletForm.defaultProps = {
  activatePalletId: true
}


const ReduxForm = reduxForm({
  form: "RegisterPalletForm"
})(RegisterPalletForm);

export default ReduxForm;